import { Component, OnInit, inject } from '@angular/core';
import { NotificationCenterService } from '../notification-center.service';
import { PhitoNotificationConfiguration } from '../classes/PhitoNotificationConfiguration';
import { PhitoNotificationSubscription } from '../classes/PhitoNotificationSubscription';
import { PhitoNotificationSubscriptionType } from '../classes/PhitoNotificationSubscriptionType';
import { MatSlideToggleChange, MatSlideToggle } from '@angular/material/slide-toggle';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { PhitoSessionService } from '../../../services/phito-session.service';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatList } from '@angular/material/list';

@Component({
    selector: 'phito-notification-settings-list',
    templateUrl: './notification-settings-list.component.html',
    styleUrls: ['./notification-settings-list.component.scss'],
    imports: [
        MatFormField,
        MatLabel,
        MatInput,
        FormsModule,
        ReactiveFormsModule,
        MatIconButton,
        MatSuffix,
        MatIcon,
        MatList,
        MatSlideToggle,
    ],
})
export class NotificationSettingsListComponent implements OnInit {
    private notificationCenterService = inject(NotificationCenterService);
    private sessionService = inject(PhitoSessionService);

    settings: PhitoNotificationConfiguration[] = [];
    subscriptionType = PhitoNotificationSubscriptionType;
    searchCtrl: FormControl = new FormControl();

    ngOnInit(): void {
        this.loadSettings();

        this.searchCtrl.valueChanges.subscribe(() => {
            this.searchCtrl.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe(() => {
                this.search();
            });
        });
    }

    loadSettings() {
        this.notificationCenterService.getNotificationSettings().subscribe({
            next: (response) => {
                console.log('LOAD SETTINGS', response);
                this.settings = <PhitoNotificationConfiguration[]>response.data;
            },
            error: (err) => {
                console.log('LOAD SETTINGS ERROR', err);
            },
        });
    }

    getUserSubscriptionTypes(setting: PhitoNotificationConfiguration): PhitoNotificationSubscriptionType[] {
        // find user subscription
        return this.getUserSubscription(setting)?.subscriptionTypes;
    }

    getUserSubscription(setting: PhitoNotificationConfiguration): PhitoNotificationSubscription {
        return setting.subscriptions?.find((subscription) => {
            return subscription.user.userHexId === this.sessionService.loggedInUser().userHexId;
        });
    }

    isChecked(type: PhitoNotificationSubscriptionType, setting: PhitoNotificationConfiguration): boolean {
        return !!this.getUserSubscriptionTypes(setting)?.find((subscription) => {
            return subscription === type;
        });
    }

    anyChecked(setting: PhitoNotificationConfiguration) {
        return this.getUserSubscriptionTypes(setting)?.length > 0;
    }

    addSubscription(
        $event: MatSlideToggleChange,
        type: PhitoNotificationSubscriptionType,
        setting: PhitoNotificationConfiguration,
    ) {
        console.log('ADD SUBSCRIPTION', $event, type, setting);
        const subscription = this.getUserSubscription(setting) || new PhitoNotificationSubscription();
        console.log('SUBSCRIPTION', subscription);
        if ($event.checked) {
            if (!subscription) {
                // create new subscription
                subscription.user = this.sessionService.loggedInUser();
                subscription.subscriptionTypes = [type];
            } else {
                // add to existing subscription
                subscription.subscriptionTypes.push(type);
            }
        } else {
            // remove from existing subscription
            subscription.subscriptionTypes = subscription.subscriptionTypes.filter((subscriptionType) => {
                return subscriptionType !== type;
            });
        }
        console.log('NEW SUBSCRIPTION', subscription);

        this.notificationCenterService.addSubscription(setting.id, subscription).subscribe({
            next: (response) => {
                console.log('ADD SUBSCRIPTION', response);
                this.loadSettings();
            },
            error: (err) => {
                console.log('ADD SUBSCRIPTION ERROR', err);
            },
        });
    }

    private search() {
        const searchTxt = this.searchCtrl.value;
        this.notificationCenterService.getNotificationConfiguration(searchTxt).subscribe({
            next: (response) => {
                this.settings = <PhitoNotificationConfiguration[]>response.data;
            },
        });
    }
}
